/**
 * @fileoverview Zod schema for the login form.
 * @description Runs before the login request is sent so obviously-invalid input never reaches the
 * API layer. Only checks presence/shape — server-side credential checking still happens in the
 * login request itself. The identity backend only accepts an email address (no separate username),
 * so this schema validates email format client-side too. Every issue message is a translation key
 * (per this repo's i18n rule for validators), translated only at the display call site in
 * LoginForm.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

import { emailField } from '@/shared/lib/validation/contact-fields.schema'

export const loginFormSchema = z.object({
  identifier: emailField({
    required: 'login.errors.emailRequired',
    invalid: 'login.errors.emailInvalid',
  }),
  password: z.string().min(1, 'login.errors.passwordRequired'),
})

export type LoginFormValues = z.infer<typeof loginFormSchema>
